import { runoutTimes } from '@constants/orderDispatch'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import { TimeSpanFilter } from '../TimeSpan/TimeSpan'
import { filterByRunoutTime } from './runoutFilter'

/** @deprecated - Should use OrderManagement/Grid/Filters/TimeDeadlineFilter/index.tsx instead */
export default forwardRef((props, ref) => {
  const [selectedOptions, setSelectedOptions] = useState('')
  const buttons = [
    { text: '12 Hours', value: runoutTimes.HALFDAY, className: 'mt-4 ml-3 mr-3' },
    { text: '24 Hours', value: runoutTimes.DAY, className: 'mt-3 ml-3 mr-3' },
    { text: '3 Days', value: runoutTimes.THREEDAYS, className: 'mt-3 ml-3 mr-3' },
    { text: 'Next Week', value: runoutTimes.WEEK, className: 'pt-3 pl-3 pr-3 pb-4 bottom-border' },
  ]
  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        if (params.data.type?.toLowerCase() === 'backhaul') return false
        const runoutPasses = filterByRunoutTime(
          props.accessor3
            ? params.data?.[props.accessor]?.[props.accessor2]?.[props.accessor3]
            : props.accessor
              ? params.data?.[props.accessor]
              : params.data.dispatch_window_end,
          selectedOptions
        )
        return runoutPasses
      },
      isFilterActive() {
        return !!selectedOptions
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [selectedOptions])

  const onClick = (value) => {
    if (selectedOptions && selectedOptions.includes(value)) {
      setSelectedOptions('')
    } else {
      setSelectedOptions(value)
    }
  }

  const onClear = () => {
    setSelectedOptions(null)
  }
  return <TimeSpanFilter buttons={buttons} onClear={onClear} onClick={onClick} selectedOptions={selectedOptions} />
})
